// createdAt arrives as a Firestore Timestamp, a numeric epoch, or undefined
// depending on read path, so normalise to a Date before using it.
function toDate(value: unknown): Date | null {
  if (value == null) {
    return null;
  }
  if (value instanceof Date) {
    return value;
  }
  if (typeof value === "number") {
    // Values below ~1e12 are second-precision epochs; everything else is ms.
    return new Date(value < 1e12 ? value * 1000 : value);
  }
  if (typeof value === "object") {
    const candidate = value as { toDate?: () => Date; seconds?: number };
    if (typeof candidate.toDate === "function") {
      return candidate.toDate();
    }
    if (typeof candidate.seconds === "number") {
      return new Date(candidate.seconds * 1000);
    }
  }
  return null;
}

// Epoch milliseconds for sorting; missing/invalid dates collapse to 0 (oldest).
export function createdAtMillis(value: unknown): number {
  const date = toDate(value);
  if (!date || Number.isNaN(date.getTime())) {
    return 0;
  }
  return date.getTime();
}

export function formatCreatedAt(value: unknown): string {
  const date = toDate(value);
  if (!date || Number.isNaN(date.getTime())) {
    return "-";
  }
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
